import { render, staticRenderFns } from "./wxredirect.vue?vue&type=template&id=8ad0f96e&scoped=true&"
import script from "./wxredirect.vue?vue&type=script&lang=ts&"
export * from "./wxredirect.vue?vue&type=script&lang=ts&"
import style0 from "./wxredirect.vue?vue&type=style&index=0&id=8ad0f96e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad0f96e",
  null
  
)

export default component.exports